module.exports = __webpack_public_path__ + "img/visa-mastercard.576ab76e.png";